import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import colors from '../styles/colors';


const drawerWidth = 240;



const Layout = ({ children }) => {

    const lang = useSelector((state) => state.authReducer.lang);
    const theme = useTheme();
    // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isMobile = useMediaQuery(theme.breakpoints.between('xs', 'md'));
    const [sidebarOpen, setSidebarOpen] = useState(isMobile ? false : true);






    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };


    useEffect(() => {
        setSidebarOpen(isMobile ? false : true);
    }, [isMobile])


    return (
        <Box

            sx={{ display: 'flex' }}>
            <Navbar toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
            <Sidebar open={sidebarOpen} drawerWidth={drawerWidth} />

            {/* Content Area */}

            <Box

                component="main"
                sx={{
                    flexGrow: 1,
                    marginTop: 5,
                    fontFamily: 'IRe',
                    bgcolor:colors.bg,
                    // padding: '16px',
                    // marginLeft: lang == 'ar' ? 0 : sidebarOpen ? `${drawerWidth}px` : '0',
                    // marginRight: lang == 'en' ? 0 : sidebarOpen ? `${drawerWidth}px` : '0',
                    transition: 'margin-left 0.3s ease',
                    height: '100vh', // Full screen height


                }}
            >
                <div style={{ marginTop: 20 }} />

                {children}
            </Box>
        </Box>
    )
}

export default Layout
